import { constantsData, formFieldNamesData } from "@/data";
import { InputTypeEnum } from "@/enums";

const { email } = constantsData.forms.auth.forgetPassword;
const { email: emailFieldName } = formFieldNamesData;

export const forgetPasswordFormData = [
    {
        label: email.label,
        name: emailFieldName,
        type: InputTypeEnum.EMAIL,
    },
];
